import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-dienstplan';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsVeranstaltungDienstplanEffects {

    VeranstaltungDienstplan$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_DIENSTPLAN),
        mergeMap((x: ac.GetVeranstaltungDienstplanAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungDienstplan(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungDienstplanErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungDienstplanFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
